import React from "react";
import { Link } from "react-router-dom";
import "./top.css";
const TopStory = ({ posts = [] }) => {
  if (posts.length === 0) return null;

  const mainPost = posts[0];

  const mainvidurl = mainPost.vid.split("=")[1];

  const otherPosts = posts.slice(1);

  return (
    <div className="topStories">
      <h2>Top Stories</h2>
      {/* Main Top Card */}
      <Link to={`/post/${mainPost.id}`}>
        <div className="card">
          <div className="cardimg">
            {mainPost.img ? (
              <img src={mainPost.img} alt={mainPost.title} />
            ) : mainvidurl ? (
              <img
                src={`https://img.youtube.com/vi/${mainvidurl}/maxresdefault.jpg`}
                alt=""
              />
            ) : (
              <img
                style={{ objectFit: "scale-down" }}
                src="/images/WhatsApp Image 2025-07-24 at 10.13.04_6e1f9894.jpg"
                alt={mainPost.title}
              />
            )}
            <h3>{mainPost.title}</h3>
          </div>
        </div>
      </Link>
      {/* Small Cards */}
      {otherPosts.map((post) => (
        <Link to={`/post/${post.id}`} key={post.id}>
          <div className="smallcard">
            {post.img ? (
              <img src={post.img} alt={post.title} className="smallcardimg" />
            ) : post.vid ? (
              <img
                className="smallcardimg"
                src={`https://img.youtube.com/vi/${
                  post.vid.split("=")[1]
                }/maxresdefault.jpg`}
                alt=""
              />
            ) : (
              <img
                src="/images/WhatsApp Image 2025-07-24 at 10.13.04_6e1f9894.jpg"
                style={{ objectFit: "scale-down" }}
                alt={post.title}
                className="smallcardimg"
              />
            )}
            <h5 className="smallcarddesc">{post.title}</h5>
          </div>
        </Link>
      ))}{" "}
      <Link
        to={"/top-stories"}
        style={{
          width: "100%",
          color: "black",
          display: "flex",
          justifyContent: "right",
          paddingRight: "2px",
          fontSize: "large",
          fontWeight: "bold",
          color: "#81556E",
          textDecoration: "underline",
        }}
        className="desc"
      >
        See More
      </Link>
      {/* <div
        className="nav-btn"
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          margin: "10px auto",
        }}
      >
        <Link to={"/about"} className="btn btn-primary text-white ">
          About Us
        </Link>
        <Link to={"/contact"} className="btn btn-primary text-white">
          Contact Us
        </Link>
      </div> */}
    </div>
  );
};

export default TopStory;
